// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiPayor {
    'bin'?: string;
    'cardHolderId'?: string;
    'groupId'?: string;
    'groupName'?: string;
    'id'?: string;
    'name'?: string;
    'otherInsuranceStatus'?: string;
    'pcn'?: string;
    'phone'?: string;
    'planName'?: string;
    'globalPayorId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiPayor>> = [
        {
            "name":     "bin",
            "baseName": "bin",
            "type":     "string"
        },
        {
            "name":     "cardHolderId",
            "baseName": "cardHolderId",
            "type":     "string"
        },
        {
            "name":     "groupId",
            "baseName": "groupId",
            "type":     "string"
        },
        {
            "name":     "groupName",
            "baseName": "groupName",
            "type":     "string"
        },
        {
            "name":     "id",
            "baseName": "id",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "otherInsuranceStatus",
            "baseName": "otherInsuranceStatus",
            "type":     "string"
        },
        {
            "name":     "pcn",
            "baseName": "pcn",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "planName",
            "baseName": "planName",
            "type":     "string"
        },
        {
            "name":     "globalPayorId",
            "baseName": "globalPayorId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiPayor.attributeTypeMap;
    }
}
